import { combineReducers } from 'redux';

import listReducer, { DeliveryAreasListState } from './list/reducer';
import detailReducer, { DeliveryAreaDetailState } from './detail/reducer';
import v3MultiAreaReducer, {
  DeliveryAreasV3MultiAreaState,
} from './v3-3/reducer';

export interface DeliveryAreasState {
  list: DeliveryAreasListState;
  detail: DeliveryAreaDetailState;
  v3MultiArea: DeliveryAreasV3MultiAreaState;
}

export default combineReducers({
  list: listReducer,
  detail: detailReducer,
  v3MultiArea: v3MultiAreaReducer,
});
